export const initManufacturingMaterialCategory = (category = {}) => ({
    ...category,

    _id: category?._id,

    _parent: category?._parent,
    _parents: [...(category?._parents ?? [])],

    code: category?.code ?? null,
    name: category?.name ?? null,

    depth: category?.depth ?? 1,
    index: category?.index ?? 1,
    shows: category?.shows ?? 1,
});
